import { FC } from 'react'
import styled from 'styled-components'

interface AccessRestrictionNoticeProps {}

const AccessRestrictionNotice: FC<AccessRestrictionNoticeProps> = ({
  children,
}) => {
  return <StyledWrapper>{children}</StyledWrapper>
}

export default AccessRestrictionNotice

const StyledWrapper = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  min-height: max-content;
  width: 100%;
  height: 100%;
  background-color: rgba(51, 51, 51, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
`
